import { DatePicker as XDP } from "@mui/x-date-pickers/DatePicker";
import { parseValidDate } from "../../utils";
import { useMemo } from "react";
import moment from "moment";
import { DatePickerProps } from "@mui/lab";

export default function DatePicker({ value, ...props }: DatePickerProps) {
    const v = useMemo(() => {
        var dt = parseValidDate(value);
        if (dt) {
            return moment(dt);
        }
    }, [value]);

    return <XDP value={v} {...props} />;
}